import React from 'react';
import { graphql } from 'react-apollo';
import Select from 'react-select';
import TOGGLE_USER_INFO_TYPE_MUTATION from '../../../../graphql/ToggleUserInfoType';

const options = [{ label: 'Básica', value: 'basic' }, {
  label: 'Full', value: 'full',
}];

class ToggleUserStats extends React.Component {
  toggleUserInfoType = (e) => {
    const { mutate, id } = this.props;
    mutate({
      variables: {
        infoType: e.value,
        id,
      },
    })
      .then(() => this.props.onAfterUpdate())
      .catch((err) => {
        console.error(err);
      });
  };

  alertUpdate = (e) => {
    if (window.confirm('¿Estás seguro que deseas modificar la ficha de este artista?')) {
      this.toggleUserInfoType(e);
    }
  }

  render() {
    return (
      <Select
        menuPortalTarget={document.body}
        styles={{
          menuPortal: base => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        menuPlacement="bottom"
        menuPosition="fixed"
        onChange={this.alertUpdate}
        value={options.filter(option => option.value === this.props.infoType)}
        options={options}
      />
    );
  }
}
const withMutation = graphql(TOGGLE_USER_INFO_TYPE_MUTATION);

export default withMutation(ToggleUserStats);



// WEBPACK FOOTER //
// ./src/containers/Admin/Artist/ToggleInfoType/index.js